(function () {
  'use strict';

  function init(tabList) {
    if (!tabList || tabList.dataset.shopAllInitialized === 'true') return;
    tabList.dataset.shopAllInitialized = 'true';

    var tabs = Array.prototype.slice.call(
      tabList.querySelectorAll('[data-shop-all-tab]')
    );
    if (tabs.length === 0) return;

    var grid = document.querySelector('[data-shop-all-grid]');
    var emptyState = document.querySelector('[data-shop-all-empty]');
    var resetBtn = document.querySelector('[data-shop-all-reset]');

    if (!grid) return;

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('[data-shop-all-card]')
    );
    var validBrands = tabs.map(function (tab) {
      return tab.dataset.brand;
    });
    var defaultBrand = tabList.dataset.defaultBrand || 'all';

    function countVisible(brand) {
      if (brand === 'all') return cards.length;
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        var raw = cards[i].dataset.brandTags || '';
        var tags = raw.split(/\s+/);
        if (tags.indexOf(brand) !== -1) n++;
      }
      return n;
    }

    function syncUrl(brand) {
      try {
        var url = new URL(window.location.href);
        if (brand === 'all' || brand === defaultBrand) {
          url.searchParams.delete('brand');
        } else {
          url.searchParams.set('brand', brand);
        }
        window.history.replaceState(null, '', url.toString());
      } catch (err) {
        // If URL APIs aren't available for any reason, fail silently.
        // Filtering still works visually; only the URL fails to sync.
      }
    }

    function setActiveBrand(brand, options) {
      options = options || {};
      var focusTab = options.focusTab === true;
      var updateUrl = options.updateUrl !== false;

      if (validBrands.indexOf(brand) === -1) brand = defaultBrand;

      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        var isActive = tab.dataset.brand === brand;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && focusTab) tab.focus();
      }

      grid.setAttribute('data-active-brand', brand);

      var visible = countVisible(brand);
      var isEmpty = visible === 0 && brand !== 'all';
      grid.classList.toggle('is-empty', isEmpty);
      if (emptyState) {
        if (isEmpty) emptyState.removeAttribute('hidden');
        else emptyState.setAttribute('hidden', '');
      }

      if (updateUrl) syncUrl(brand);
    }

    function getInitialBrand() {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = params.get('brand');
        if (fromUrl && validBrands.indexOf(fromUrl) !== -1) return fromUrl;
      } catch (err) {}
      return defaultBrand;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveBrand(tab.dataset.brand);
      });
    });

    tabList.addEventListener('keydown', function (e) {
      var currentIdx = -1;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i] === document.activeElement) {
          currentIdx = i;
          break;
        }
      }
      if (currentIdx === -1) return;

      var nextIdx;
      switch (e.key) {
        case 'ArrowRight':
          nextIdx = (currentIdx + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          nextIdx = (currentIdx - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIdx = 0;
          break;
        case 'End':
          nextIdx = tabs.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      setActiveBrand(tabs[nextIdx].dataset.brand, { focusTab: true });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        setActiveBrand('all', { focusTab: true });
      });
    }

    setActiveBrand(getInitialBrand(), { updateUrl: false });
  }

  function boot() {
    var tabLists = document.querySelectorAll('[data-shop-all-tablist]');
    for (var i = 0; i < tabLists.length; i++) init(tabLists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var lists = e.target.querySelectorAll('[data-shop-all-tablist]');
    for (var i = 0; i < lists.length; i++) init(lists[i]);
  });
})();
